import { useCallback } from 'react';
import allActions from '../actions/index';
import { useDispatch } from 'react-redux';
import consoleLogDev from './loggingHelper';
import { USE_RETRIEVE_DATA_EVENTS } from './useRetrieveData';
import useEventEmitter from './useEventEmitter';

const useRefreshCounter = (componentName) => {
    const dispatch = useDispatch();
    const applyEmitterHandler = useEventEmitter(componentName);

    const refresh = useCallback(() => {
        consoleLogDev('Calling dispatch for refreshCounter - incrementRefreshCounter');
        dispatch(allActions.refreshCounterActions.incrementRefreshCounter(componentName));

        applyEmitterHandler((emitter) => {
            emitter.emit(USE_RETRIEVE_DATA_EVENTS.ON_REFRESH, componentName);
        });
    }, [dispatch, applyEmitterHandler, componentName]);

    return refresh;
}

export default useRefreshCounter;